export const EShapeActionOpenDialogExtensions = wcardinal.ui.EShapeActionOpenDialogExtensions;